// eslint-disable-next-line import/no-anonymous-default-export
export default {
  payments: 'Payments',
  // Header specific
  selectLanguage: 'Select Language',
  confirmLogout: 'Are you sure you want to logout?',
  lightMode: 'Switch to Light Mode',
  darkMode: 'Switch to Dark Mode',
  logout: 'Logout',
  user: 'User'
};
